import axios from 'axios'

export default {
    getOrdersStat: () => axios.get(`/statistic/order`),
    getBookingStat: () => axios.get(`/statistic/booking`),
    getCustomerStat: () => axios.get(`/statistic/customer`),
    getLogsStat: (page, limit, sortBy, sort) => axios.get(`/statistic/logs`, {
        params: {
            page,
            limit,
            sort: sort[0],
            sortBy: sortBy[0]
        },
    }),
    getProductsStat: (filter) => axios.get(`/statistic/products`, {
        params: {
            filter: filter
        }
    })
}
